export default __webpack_public_path__ + "static/media/docker.50e086a3.png";